export default __webpack_public_path__ + "logo14adc27f.png";